export class Message {
  id: string;
  message: string;
  source: 'user' | 'doctor' | 'whatsapp' | 'assistant' | 'other' | 'system';
  date: Date;
  chatVersion?: string = '1';
  application: string = 'web';
  end?: boolean = false;
  sessionId?: string;
  userId: string;
}
